/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"
import PropTypes from "prop-types"
// import { useStaticQuery, graphql } from "gatsby"
import Footer from "./Global/Footer"
import Navbar from "./Global/Navbar"

import "./bootstrap.min.css"
import "./layout.css"

const Layout = ({ children }) => (
  <>
    <Navbar />
    {children}
    <Footer currentYear={new Date().getFullYear()} />
    {/*currentYear here is a prop*/}
  </>
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
